import { atom } from "recoil";

const estimateFleetImageAtom = atom({
    key: "estimateFleetImageValue",
    default: []
});

export default estimateFleetImageAtom;